import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstationcab() {



  const cardData =
  {
    keyword: 'Pune Outstation Cab',
    heading: 'Sai Trupti Cabs: Pune Outstation Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune out-station cab services, designed to make your long-distance journeys smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving throughout the route. With transparent one-way or round-trip fares, flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your out-station travel from Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala, nestled in the Sahyadri ranges just 65 km from Pune, is one of Maharashtra’s most loved hill stations. Famous for its misty valleys, green hills, and delicious chikki, it offers a refreshing retreat throughout the year. Tourists flock to viewpoints like Tiger’s Leap, Lion’s Point, and Bhushi Dam to enjoy scenic vistas and waterfalls during the monsoon. The cool air, winding roads, and cozy resorts make it ideal for family picnics, romantic getaways, and quick weekend breaks. Whether you’re sipping tea by the ghats or trekking to Rajmachi Fort, Lonavala promises relaxation and rejuvenation close to Pune."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located about 120 km from Pune, is a lush plateau surrounded by dense forests, strawberry farms, and spectacular viewpoints. This charming hill station is home to attractions like Arthur’s Seat, Venna Lake, and Mapro Garden, making it a top favorite for nature lovers. Visitors can enjoy boating on the lake, tasting fresh berries, or horse riding through misty trails. The cool mountain climate and British-era charm add to its romantic allure. With scenic sunrises, tranquil temples, and panoramic valley views, Mahabaleshwar offers an unforgettable outstation experience from Pune."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, India’s first planned hill city, is just 60 km from Pune and known for its stunning Italian-inspired architecture and lakeside promenade. Built along the banks of Warasgaon Lake, it offers a perfect blend of nature and modern comfort. Visitors can indulge in kayaking, jet-skiing, cycling, or simply strolling along colorful cobblestone streets lined with cafés. Surrounded by green hills and fresh mountain air, Lavasa feels like a slice of Europe tucked in Maharashtra. It’s an ideal weekend getaway for families, couples, and photographers seeking serenity with a touch of luxury."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani, meaning 'five hills', lies just beyond Mahabaleshwar and charms visitors with its tranquil valleys, strawberry gardens, and colonial-era boarding schools. The Table Land plateau, one of Asia’s largest, offers panoramic views and a perfect spot for paragliding or horse riding. Sydney Point, Parsi Point, and Devil’s Kitchen reveal breathtaking landscapes that captivate every traveler. With its cool breeze, scenic sunsets, and peaceful ambiance, Panchgani serves as a delightful outstation destination for those seeking quiet beauty away from Pune’s rush."
  },
  {
    "title": "Matheran",
    "description": "Matheran, India’s smallest hill station located about 120 km from Pune, is a pollution-free paradise where vehicles are not allowed. Visitors travel up via a toy train or scenic trek and are greeted by red soil trails, colonial cottages, and panoramic points like Echo Point and Panorama Point. The crisp mountain air, tall trees, and quiet paths make it a favorite spot for nature lovers and trekkers. Horse rides and hand-pulled rickshaws add to the vintage charm. Matheran is where time slows down, offering pure calm and natural splendor."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, located 140 km from Pune, is a coastal gem known for its pristine beaches, forts, and laid-back vibes. Popular beaches like Kashid, Nagaon, and Alibaug Beach attract tourists seeking seaside relaxation. The Kolaba Fort, accessible by foot during low tide, offers a glimpse into Maratha maritime history. Alibaug also delights foodies with fresh seafood and local Konkani delicacies. Whether it’s a romantic seaside retreat or a fun family outing, Alibaug’s clean sands and coastal breeze make it a top outstation pick from Pune."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, about 110 km from Pune, is one of Maharashtra’s 12 Jyotirlingas and a revered pilgrimage site dedicated to Lord Shiva. The temple, nestled amid the lush Sahyadri forests, exudes a serene and spiritual atmosphere. Nature enthusiasts love exploring the Bhimashankar Wildlife Sanctuary, home to the Indian Giant Squirrel and numerous bird species. The monsoon season adds charm with mist-filled valleys and waterfalls cascading through the greenery. Combining devotion and natural beauty, Bhimashankar is both a spiritual retreat and a nature lover’s delight."
  },
  {
    "title": "Nashik",
    "description": "Nashik, around 210 km from Pune, is Maharashtra’s wine capital and a major religious center. The city hosts the famous Kumbh Mela and is home to ancient temples along the Godavari River such as Kalaram and Trimbakeshwar. Wine enthusiasts can tour premium vineyards like Sula and York, tasting fine wines amid rolling vineyards. Nashik’s blend of heritage, devotion, and modern luxury makes it an ideal outstation destination. Whether for a spiritual journey or a vineyard getaway, Nashik invites travelers to explore its unique rhythm of tradition and sophistication."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, about 185 km from Pune, is one of India’s most visited spiritual destinations, renowned as the home of Shri Sai Baba. The temple complex attracts millions of devotees who come seeking peace and blessings. The aura of devotion, rhythmic chants, and serene surroundings make Shirdi deeply moving. Beyond the temple, places like Dwarkamai and Chavadi reflect Sai Baba’s life and teachings. The well-maintained roads and amenities make it a comfortable and spiritually fulfilling outstation journey from Pune."
  },
  {
    "title": "Khandala",
    "description": "Khandala, located just a few kilometers beyond Lonavala, offers misty hills, romantic viewpoints, and lush greenery. The Duke’s Nose viewpoint provides stunning panoramic views, while waterfalls and scenic valleys make it a monsoon paradise. Travelers from Pune love the short, scenic drive along the Mumbai-Pune Expressway, filled with mountain tunnels and breathtaking turns. Whether you’re trekking, capturing photos, or sipping tea with clouds drifting by, Khandala makes for a picture-perfect escape. It’s an evergreen favorite for weekend travelers seeking quick rejuvenation."
  }
],



"services": [
  {
    "name": "Pune Outstation Cab",
    "description": "Reliable Pune outstation cab service offering AC and Non-AC options, professional drivers, and luggage support. Ideal for long-distance travel, weekend getaways, family trips, and corporate journeys, ensuring a safe, comfortable, and hassle-free ride."
  },
  {
    "name": "Outstation Taxi Service Pune",
    "description": "Professional outstation taxi service in Pune with well-maintained AC/Non-AC vehicles, experienced drivers, and flexible pickup/drop options. Perfect for corporate travel, weddings, family outings, and weekend trips, offering punctual and comfortable transportation."
  },
  {
    "name": "Pune Outstation Car Hire",
    "description": "Flexible outstation car hire service in Pune with AC and Non-AC cars, professional drivers, and luggage assistance. Suitable for one-way trips, round trips, corporate travel, and family excursions, providing safe, reliable, and comfortable journeys."
  },
  {
    "name": "Pune AC Outstation Cab",
    "description": "Comfortable AC outstation cab service in Pune with professional drivers, luggage support, and flexible scheduling. Ideal for long-distance trips, corporate travel, and family vacations, ensuring a smooth and enjoyable ride."
  },
  {
    "name": "Pune Non AC Outstation Cab",
    "description": "Economical Non-AC outstation cab service in Pune with professional drivers, luggage assistance, and flexible pickup/drop options. Perfect for budget-friendly travel, family outings, and corporate trips without compromising safety and comfort."
  },
  {
    "name": "Luxury Outstation Cab Pune",
    "description": "Premium luxury outstation cab service in Pune with high-end AC vehicles, professional chauffeurs, and luggage support. Ideal for weddings, VIP travel, corporate events, and special occasions, offering stylish, safe, and comfortable long-distance travel."
  },
  {
    "name": "Pune Innova Outstation Cab",
    "description": "Reliable Innova outstation cab service in Pune with AC and Non-AC options, professional drivers, and luggage assistance. Suitable for family trips, corporate travel, weddings, and long-distance journeys, providing spacious and comfortable travel."
  },
  {
    "name": "Pune Ertiga Outstation Cab",
    "description": "Spacious Ertiga outstation cab service in Pune with AC and Non-AC options, professional drivers, and luggage support. Perfect for family outings, corporate trips, and group travel, ensuring comfort, safety, and timely arrivals on long journeys."
  },
  {
    "name": "Affordable Outstation Cab Pune",
    "description": "Cost-effective outstation cab service in Pune with AC/Non-AC options, professional drivers, and luggage assistance. Ideal for budget-conscious travelers, families, and corporate clients looking for safe, reliable, and economical long-distance transport."
  },
  {
    "name": "Pune Outstation One Way Cab",
    "description": "Convenient one-way outstation cab service from Pune with AC and Non-AC vehicles, professional drivers, and luggage support. Suitable for airport transfers, long-distance drop-offs, and point-to-point travel, offering a hassle-free and smooth journey."
  },
  {
    "name": "Pune Outstation Drop Cab",
    "description": "Reliable drop cab service from Pune for outstation travel with AC/Non-AC vehicles, professional drivers, and luggage support. Perfect for weekend trips, business travel, and family outings, providing safe, timely, and comfortable journeys."
  },
  {
    "name": "Corporate Outstation Cab Pune",
    "description": "Specialized corporate outstation cab service in Pune with AC vehicles, experienced drivers, luggage support, and flexible scheduling. Ideal for business trips, client meetings, and corporate events, ensuring punctual, safe, and professional transportation."
  },
  {
    "name": "Wedding Outstation Cab Pune",
    "description": "Luxury outstation cab service in Pune for weddings with AC/Non-AC options, professional drivers, luggage support, and timely pickups. Perfect for transporting guests, family members, or VIPs, offering comfort, style, and reliable travel for special occasions."
  },
  {
    "name": "Online Outstation Cab Pune",
    "description": "Book your outstation cab from Pune online instantly with secure payment options, AC/Non-AC vehicle choices, professional drivers, and luggage assistance. Suitable for last-minute trips, planned travel, and corporate journeys, ensuring a smooth and comfortable ride."
  },
  {
    "name": "Best Outstation Cab Pune",
    "description": "Top-rated outstation cab service in Pune offering AC/Non-AC vehicles, professional drivers, luggage support, and flexible scheduling. Perfect for corporate travel, weddings, family trips, and long-distance journeys, providing safe, reliable, and premium transportation."
  }
],
"tableData": [
  ["Pune Outstation Cab", "Outstation Taxi Service Pune"],
  ["Pune Outstation Car Hire", "Pune AC Outstation Cab"],
  ["Pune Non AC Outstation Cab", "Luxury Outstation Cab Pune"],
  ["Pune Innova Outstation Cab", "Pune Ertiga Outstation Cab"],
  ["Affordable Outstation Cab Pune", "Pune Outstation One Way Cab"],
  ["Pune Outstation Drop Cab", "Corporate Outstation Cab Pune"],
  ["Wedding Outstation Cab Pune", "Online Outstation Cab Pune"],
  ["Best Outstation Cab Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune Outstation Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable outstation cab services from Pune — perfect for trips to nearby cities, tourist destinations, and long-distance travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear and affordable fares for Pune outstation cab rides — no hidden charges, with options for one-way or round trips based on distance and vehicle type."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers depending on your group size, luggage, and travel comfort requirements."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers ensure a safe, smooth, and timely journey for every outstation cab ride from Pune."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune and drop-offs at your desired outstation destination, including hotels, railway stations, or tourist spots."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and maintained to ensure comfort, safety, and reliability during long-distance travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune outstation cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune outstation cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable outstation cab services from Pune for one-way trips, round trips, and long-distance travel.',
  },
  {
    question: 'How can I book an outstation cab from Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune outstation cab through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of cabs are available for outstation trips from Pune?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune outstation trips?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for long-distance travel, ensuring a safe and comfortable journey from Pune.',
  },
  {
    question: 'Can I hire an outstation cab from Pune for family, corporate, or group travel?',
    answer: 'Certainly. Our outstation cab services cater to family trips, group tours, corporate travel, and sightseeing journeys from Pune.',
  },
  {
    question: 'Is the Pune outstation cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 outstation cab services from Pune for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the fares for Pune outstation cab services?',
    answer: 'Outstation cab fares from Pune start from approximately ₹1,500 for short distances, and ₹2,500–₹5,000 for longer trips depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Pune outstation cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free and secure transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune outstation cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene measures to ensure a secure journey for outstation travel.',
  },
  {
    question: 'Is customer support available during Pune outstation cab trips?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Pune outstation cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Patil',
    feedback: 'I booked an outstation cab from Pune with Sai Trupti Cabs. The ride was comfortable, the driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    feedback: 'Sai Trupti Cabs provided excellent outstation cab service from Pune. Smooth journey and very courteous driver.',
    rating: 5,
  },
];










































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Outstation Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-outstation-cab.jpg",
  "description": "Book Pune Outstation Cabs with Sai Trupti Cabs for comfortable travel. Choose AC or Non-AC options, luxury rides, corporate trips, weddings, one-way or round trips. Affordable and reliable online cab booking 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1450"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2000",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-outstation-cab"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Pune Outstation Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune Outstation Cabs with Sai Trupti Cabs for comfortable travel. Choose AC or Non-AC options, luxury rides, corporate trips, weddings, one-way or round trips. Affordable and reliable online cab booking 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune Outstation Cab, Outstation Taxi Service Pune, Pune Outstation Car Hire, Pune AC Outstation Cab, Pune Non AC Outstation Cab, Luxury Outstation Cab Pune, Pune Innova Outstation Cab, Pune Ertiga Outstation Cab, Affordable Outstation Cab Pune, Pune Outstation One Way Cab, Pune Outstation Drop Cab, Corporate Outstation Cab Pune, Wedding Outstation Cab Pune, Online Outstation Cab Pune, Best Outstation Cab Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneoutstationcab;